var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$userInfo
    ? _c(
        "div",
        [
          _c("app-detail-header", {
            attrs: {
              "show-toggle": true,
              "show-delete": _vm.showDelete,
              "show-save": false,
              "show-cancel": false,
              "show-new": false,
            },
            on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
          }),
          _c("div", { staticClass: "columns is-gapless" }, [
            _c(
              "div",
              { staticClass: "column is-narrow" },
              [
                _c("debtor-receipt-list-side-menu", {
                  on: { filter: _vm.filterList, reset: _vm.resetList },
                  model: {
                    value: _vm.filter,
                    callback: function ($$v) {
                      _vm.filter = $$v
                    },
                    expression: "filter",
                  },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "column" }, [
              _c("div", { staticClass: "tile is-parent" }, [
                _c(
                  "article",
                  { staticClass: "tile is-child box" },
                  [
                    _c(
                      "bulma-table",
                      {
                        staticClass:
                          "table is-bordered is-striped is-narrow is-fullwidth",
                        attrs: {
                          columns: _vm.columns,
                          "page-index": _vm.filter.pageIndex,
                          "page-size": _vm.filter.pageSize,
                          "total-rows": _vm.totalRows,
                          "is-loading": _vm.isTableLoading,
                          "sort-column": _vm.filter.sortColumn,
                          "sort-order": _vm.filter.sortOrder,
                        },
                        on: { pageChanged: _vm.onPageChange, sort: _vm.sort },
                      },
                      [
                        _vm._l(_vm.entitySummaries, function (entity, index) {
                          return _c(
                            "tr",
                            {
                              key: entity.invoicePaymentId,
                              class: {
                                "is-selected": _vm.selectedRow === index,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.highlightSelected(index, $event)
                                },
                              },
                            },
                            [
                              _c("td", [
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.gotoV1(
                                          entity.paymentType,
                                          entity.invoicePaymentId,
                                          entity.invoiceId,
                                          entity.adjustmentInvoiceId,
                                          entity.invoiceRef
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(entity.invoiceRef) + " "
                                    ),
                                  ]
                                ),
                              ]),
                              _c("td", [_vm._v(_vm._s(entity.debtorName))]),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatNumber(
                                      entity.amountPaid,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatDateTimezone(
                                      entity.payDate,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", [_vm._v(_vm._s(entity.chequeNo))]),
                              _c("td", [_vm._v(_vm._s(entity.bankAccount))]),
                              _c("td", { staticClass: "has-text-centered" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "icon",
                                    class: [
                                      entity.factoring
                                        ? "has-text-success"
                                        : "has-text-danger",
                                    ],
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "mdi mdi-24px",
                                      class: [
                                        entity.factoring ? "mdi-check" : "",
                                      ],
                                    }),
                                  ]
                                ),
                              ]),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatNumber(
                                      entity.gstPaid == null
                                        ? ""
                                        : entity.gstAmount,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatDateTimezone(
                                      entity.gstPaid,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c(
                                "td",
                                [
                                  _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: {
                                          path: entity.hasQuote
                                            ? `/quotes/${entity.quoteId}`
                                            : entity.hasMiscQuote
                                            ? `/miscquotes/${entity.quoteId}`
                                            : "",
                                        },
                                        append: "",
                                      },
                                    },
                                    [_vm._v(" " + _vm._s(entity.quoteNo) + " ")]
                                  ),
                                ],
                                1
                              ),
                              _c("td", { staticClass: "has-text-centered" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "button is-primary is-small is-inverted tooltip is-tooltip-topright",
                                    attrs: { "data-tooltip": "Click to view" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.gotoV1(
                                          entity.paymentType,
                                          entity.invoicePaymentId,
                                          entity.invoiceId,
                                          entity.adjustmentInvoiceId,
                                          entity.invoiceRef
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "icon is-medium" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "mdi mdi-file-document mdi-24px",
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm.checkInvoice(entity)
                                  ? _c(
                                      "a",
                                      {
                                        staticClass:
                                          "button is-danger is-small is-inverted tooltip is-tooltip-topright",
                                        attrs: {
                                          "data-tooltip": "Click to delete",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.deleteButton(entity)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "icon is-medium" },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "mdi mdi-delete mdi-24px",
                                            }),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                            ]
                          )
                        }),
                        _c("template", { slot: "empty" }, [
                          _c("section", { staticClass: "section" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "content has-text-grey has-text-centered",
                              },
                              [
                                _c(
                                  "span",
                                  { attrs: { icon: "icon is-large" } },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "mdi mdi-48px mdi-emoticon-sad",
                                    }),
                                  ]
                                ),
                                _c("p", [_vm._v("Nothing")]),
                              ]
                            ),
                          ]),
                        ]),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
          _c(
            "confirm-modal",
            {
              attrs: {
                active: _vm.isConfirmModalActive,
                "ok-text": "Yes",
                "cancel-text": "No",
              },
              on: {
                "update:active": function ($event) {
                  _vm.isConfirmModalActive = $event
                },
                ok: function ($event) {
                  return _vm.deleteEntity(true)
                },
                cancel: function ($event) {
                  return _vm.deleteEntity(false)
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Delete Debtor Receipt List"),
              ]),
              _c(
                "p",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _c(
                    "span",
                    { staticClass: "has-text-primary has-text-weight-bold" },
                    [_vm._v(_vm._s(_vm.selectedInvoiceRef))]
                  ),
                  _vm._v(" will be deleted. Continue? "),
                ]
              ),
            ]
          ),
          _vm.isLoadAdvPaymentModalActive
            ? _c(
                "advance-receipt-modal",
                {
                  attrs: {
                    active: _vm.isLoadAdvPaymentModalActive,
                    "show-icon": false,
                  },
                  on: {
                    "update:active": function ($event) {
                      _vm.isLoadAdvPaymentModalActive = $event
                    },
                    close: function ($event) {
                      return _vm.closeModal()
                    },
                  },
                },
                [
                  _c(
                    "p",
                    { attrs: { slot: "text-title" }, slot: "text-title" },
                    [_vm._v("Advance Receipt Entry")]
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }